import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { Form, FormSubmit, FormText } from '../../../../../../shared/form/form'
import { useApiFormNodeLibrary } from '../../../../../../api-new/state/content'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { AssetList } from '../../common/assets/asset-list'
import { LibraryMenu } from '../../common/menu/node-actions'
import { FormJsonEditorStr } from '../../../../../../shared/form/form-control/form-json-editor-str'
import { useDataContext } from '../data-context'

export const NodeLibraryEditSys = ({ parentURL, nodeID }) => {
  const { url } = useRouteMatch()

  const dataContext = useDataContext()

  const apiFormNodeLibrary = useApiFormNodeLibrary()

  const handleMatch = () => apiFormNodeLibrary.get(nodeID)

  const handleSubmit = async data => {
    await apiFormNodeLibrary.put(data.id, data)
    dataContext.reload()
  }

  const HeaderMenu = () => <LibraryMenu place="header" url={parentURL} />

  return (
    <React.Fragment>
      <BreadcrumbView text="sys admin edit" Icon={IconEdit} onMatch={handleMatch}>
        <CardFullHeightScrollY title="sys edit" HeaderMenu={HeaderMenu}>
          <Card>
            <Form state={apiFormNodeLibrary.form} onSubmit={handleSubmit}>
              <FormText label="name" name="name" />
              <FormJsonEditorStr label="metadata" name="metadata" />
              <FormSubmit text="update" />
            </Form>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/assets`}>
        <AssetList parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
